import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { ResolveTranslateAbleTextPipe, type TranslateAbleResolver } from '@pct-ng/i18n';
import { isFunction, isNil } from '@pct-ts/typeguard';
import type { AbstractDtoService } from '@pct-ng/core/dto';
import type { BasePaginationDTO } from '@pct-sdk/core';

@Pipe({
  name: 'resolveItemLabel',
  pure: false,
})
export class ResolveItemLabelPipe<
  SERVICE,
  CREATE_UPDATE_DTO,
  GET_DTO,
  LIST_DTO,
  ID_KEY extends keyof GET_DTO,
  GET_ALL_PARAMETERS extends { ids?: number[] | undefined; searchText?: string | undefined } = any,
  PAGINATED_DTO extends BasePaginationDTO = any,
  ID_TYPE = GET_DTO[ID_KEY],
> implements PipeTransform {
  readonly #resolveTranslateAbleTextPipe = new ResolveTranslateAbleTextPipe();

  transform(
    item: GET_DTO,
    service: AbstractDtoService<
      SERVICE,
      CREATE_UPDATE_DTO,
      GET_DTO,
      LIST_DTO,
      ID_KEY,
      GET_ALL_PARAMETERS,
      PAGINATED_DTO,
      ID_TYPE
    >,
    itemLabelResolver: TranslateAbleResolver<GET_DTO> | undefined | null,
  ): string {
    if (isNil(itemLabelResolver)) {
      return service.toString(item);
    }
    if (isFunction(itemLabelResolver)) {
      return this.#resolveTranslateAbleTextPipe.transform(itemLabelResolver(item));
    }

    return this.#resolveTranslateAbleTextPipe.transform(itemLabelResolver);
  }
}
